import { gioEvariableTrackOfPrivilege } from './tqGio';

/**
 * 转化变量上报
 * @param {Object} data 埋点字段
 */
export function gioCvariableTrack() {}

/**
 * 访问用户变量上报
 * @param {Object} data 埋点字段
 */
export function gioVisitorTrack() {}

/**
 * 事件级变量埋点
 * @param {String} action 标识符
 * @param {Object} data 埋点字段
 */
export function gioEvariableTrack() {}

/**
 * 页面级变量埋点
 * @param {*} data 埋点字段
 */
export function gioPvariableTrack() {}

/**
 * 通过页面路径查找页面级变量配置并上报 单页
 * @param {Object} pageConf 页面映射配置
 */
export function trackByRoute() {
    // route 路由实例
    return function trackByRouteInfo() {};
}

/**
 * 通过页面路径查找页面级变量配置并上报 多页
 * @param {*} pageConf 页面映射配置
 */
export function trackByHref() {}

/**
 * 获取当前页面信息
 */
export function getCurrentPageInfo() {
    return {};
}

/**
 * 更新入口信息, 该入口信息仅用于暂存，页面跳转后方会真正存储到storage.keys.lastPagePvargsOfGIO
 * 防止页面没有真正跳转，又更新了入口信息的情况，影响当前页上报数据
 * @param {String} privateEntrancePosition 入口位置
 */
export function updatePrivateEntranceInfo() {}

// 获取页面入口信息
export function getLastPagePvargsOfGIO() {
    return {
        entrancePage_var: '',
        entrancePosition_var: '',
    };
}

// 初始化 全局捕获点击事件,记录入口位置
export function initUpdateEntranceHandler() {}

/**
 * 商城事件级变量埋点(处理入口&供应商匹配)
 * @param {String} action 标识符
 * @param {Object} dataStr 埋点字段
 * @param {Boolean} isNeedEntrance 是否需要上报入口变量
 * @param {Boolean} isNeedThirdGroup 是否需要上报三级业务
 */
export function gioEvariableTrackOfShop() {}

// 上报userId
export function setUserId() {}

/**
 * 获取gio流量位参数
 * @param {*} param0
 */
export function getGioFloorVar({ module_var, floor_var = '', position_var, positionName_var }) {
    const pageInfo = getCurrentPageInfo();
    const pageName = pageInfo.pageName || '';
    return {
        pageName_var: pageName,
        module_var: module_var || pageName,
        floor_var: floor_var || '',
        position_var: String(position_var),
        positionName_var: positionName_var || '',
    };
}

/**
 * 多次上报埋点事件并剔除gio数据源
 * @param {String} event 事件标识
 * @param {{ gioList: [{ view: 'xx', click: 'xx', evar: false, data: {} }] }} data 埋点数据
 * v1.1 gioList支持传对象（单个事件场景）
 * v1.2 gioList支持选择上报事件
 */
export const gioTrackByList = (event, data) => {
    const { gioList } = data;
    if (!gioList) return data;
    if (gioList instanceof Array) {
        gioList.forEach(log => {
            doTrack(event, log);
        });
    } else {
        doTrack(event, gioList);
    }
    delete data.gioList;

    return data;
};

/**
 * 埋点上报
 * @param {*} event 事件标识 view/click
 * @param {*} log 埋点配置
 * @returns
 */
function doTrack(event, log) {
    // 转化变量上报 （event === 'click'为了避免曝光也会触发转化变量上报）
    if (event === 'click' && log.evar && log.data) {
        gioCvariableTrack(log.data);
        return;
    }
    // 事件变量上报
    if (log[event] && log.data) gioEvariableTrackOfPrivilege(log[event], { data: log.data });
}
